import { axiosBase, errorHandler } from "./axios";

const listSessions = (params?: any) => {
  return axiosBase
    .get("location-tracking/list", { params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const viewSession = (id: string) => {
  return axiosBase
    .get(`location-tracking/view/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getActiveSessions = (params?: any) => {
  return axiosBase
    .get("location-tracking/active", { params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getSessionByBatchToday = (batchId: string) => {
  return axiosBase
    .get(`location-tracking/batch/${batchId}/today`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const historyList = (params?: any) => {
  return axiosBase
    .get("location-tracking/history", { params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const viewSessionWithStudents = (id: string, params?: any) => {
  return axiosBase
    .get(`location-tracking/view/${id}/students`, { params })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const generateShareToken = (batchId: string) => {
  return axiosBase
    .post("location-tracking/share/generate", { batchId })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const disableShare = (batchId: string) => {
  return axiosBase
    .post("location-tracking/share/disable", { batchId })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

const getShareStatus = (batchId: string) => {
  return axiosBase
    .get(`location-tracking/share/status/${batchId}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
};

export const locationTrackingService = {
  listSessions,
  viewSession,
  getActiveSessions,
  getSessionByBatchToday,
  historyList,
  viewSessionWithStudents,
  generateShareToken,
  disableShare,
  getShareStatus,
};
